import { Separator as RadixSeparator } from "radix-ui";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "../lib/cn";

export type SeparatorProps = ComponentPropsWithoutRef<typeof RadixSeparator.Root>;

/**
 * Волосяная линия rgba(0,0,0,.08) — единственный разделитель в системе.
 * Толщина ровно 1px в обеих ориентациях: линия отделяет, а не рисует рамку.
 */
export function Separator({
	className,
	orientation = "horizontal",
	decorative = true,
	...rest
}: SeparatorProps) {
	return (
		<RadixSeparator.Root
			orientation={orientation}
			decorative={decorative}
			className={cn(
				"shrink-0 bg-hairline",
				orientation === "horizontal" ? "h-px w-full" : "w-px self-stretch",
				className,
			)}
			{...rest}
		/>
	);
}
